function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 16.5V13.4658C24 13.3489 23.9762 13.2333 23.9301 13.1264C23.8839 13.0195 23.8165 12.9237 23.7322 12.8451L15.5498 5.21817C15.3992 5.07778 15.203 4.99999 14.9994 5C14.7959 5.00001 14.5996 5.07781 14.449 5.21821L6.26776 12.8451C6.18342 12.9237 6.11604 13.0195 6.06993 13.1264C6.02382 13.2333 6 13.3489 6 13.4657V23.1611C6 23.3836 6.0862 23.597 6.23964 23.7543C6.39308 23.9116 6.60119 24 6.81818 24H15M15 24L20.5 26.1968M15 24V17.3937L20.5 15.1968L26 17.3937V24L20.5 26.1968M26 17.7098L20.5 19.9119M20.5 19.9119L15 17.7098M20.5 19.9119V26.1968",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.09dd45fe.svg";
export { ForwardRef as ReactComponent };